import { Component, OnChanges, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { NavigationItem } from 'src/app/models/navigation';
import { DistributionListEventSummary } from 'src/api/models';
import { ApplicationService, CustomerService, DistributionListService, FireForesightService, UserService } from 'src/api/services';
import { CustomerSelection } from 'src/service/customer.service';
import { AccountInfo } from '@azure/msal-browser';
import { FireService } from 'src/service/fire.service';
import { firstValueFrom } from 'rxjs';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-header',
  templateUrl: 'header.template.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnChanges {
  @Input() isNavigationOpen: boolean;
  @Input() showNavigation: boolean;
  @Input() isPublic: boolean;
  @ViewChild('customerMessageModal', { static: false }) customerMessageModal: ModalDirective;

  //public theme = 'dark';

  public dropdownIndex = -1;
  public activeRoute: string;

  public showAccountMenu: boolean;
  public timeZoneFilter: string;
  public customerFilter: string = "";
  public whosWatching: string[];

  constructor(
    private router: Router,
    public authService: AzureAuthService,
    //public configService: ApplicationConfigService,
    public app: ApplicationConfigService,
    public fire: FireService,
    private customerService: CustomerService,
    private userService: UserService,
    private distributionListService: DistributionListService,
    private applicationService: ApplicationService
  ) {
      // Watch for route changes
      router.events.subscribe(val => {
        const route: any = val;
        if (route.url) { this.activeRoute = route.url; }
      });


      this.timeZoneFilter = app.tenantTimeZone.split('/')[0];
      if (this.app.applicationAllowed("fire-foresight")){
        this.fire.getIncidents();
      }
    }

  ngOnChanges() {
  }

  ngOnInit(): void {
    if (this.authService.isAuthenticated()){
      this.distributionListService.DistributionListGetRecentEventsForUser().subscribe(r => {
        this.app.notifications = r;
      });
    }
  }

  ngAfterViewInit() {
    // Check if there's a customer message to display
    if (this.authService.isAuthenticated() &&
        this.authService.userProfile &&
        this.authService.userProfile.customerMessage &&
        this.authService.userProfile.customerMessage.trim() !== '') {
      // Show the modal after a short delay to ensure it's properly initialized
      setTimeout(() => {
        if (this.customerMessageModal) {
          this.customerMessageModal.show();
        }
      }, 500);
    }
  }

  changeAccount(account: AccountInfo){
    this.authService.changeAccount(account);
  }

  toggleTheme(){
    var theme = '';
    if (this.app.theme == 'dark'){
      theme = 'light'
    } else if (this.app.theme == 'light'){
      theme = 'dark'
    }
    this.app.setTheme(theme);
  }

  whoIsWatching(){
    this.userService.UserWhosOnMyPage(this.activeRoute).subscribe(r => {
      this.whosWatching = r;
    });
  }

  logout() {
   this.authService.logout();
  }

  openDropdown(index: number) {
    this.dropdownIndex = index !== this.dropdownIndex ? index : -1;
  }

  checkVisible(item: NavigationItem) : boolean {
    return true;
  }

  getCustomers(){
    return this.app.customers.filter(c => c.customerName && c.customerName.toLowerCase().indexOf(this.customerFilter.toLowerCase()) >= 0)
  }

  changeCustomer(customer){
    this.app.customerId = customer.customerId;
    this.app.setCustomerId(this.app.customerId);
    this.applicationService.ApplicationGetAllActive(this.app.customerId).subscribe(a => {
      this.app.applications = a;
      console.log(this.app.applications);
    });
    //this.customerSelected.emit({customerId:c.customerId});
  }

  trySelectCustomer(){
    let customers = this.getCustomers();
    if (customers.length == 1){
      this.changeCustomer(customers[0]);
    }
  }
}
